import React, { useState } from "react";
import "../styles/HeroSection.css";
import { Link } from "react-router-dom";
import TrailLessonModal from "../Pages/Modals/TrailLessonModal";

const HeroSection = () => {
  const [zipCode, setZipCode] = useState("");
  const [trialLessonModalVisible, setTrialLessonModalVisible] = useState(false);
  return (
    <div className="hero-section-root-container mt-4 mb-0">
      <div className="home">
        <div className="instructor-input-row hero-section mt-3 p-5 mx-5 ">
          <div className="instructor-input-column hero-text ">
            <h1>Learn Conveniently Pass Swiftly</h1>
            <p className="text-white secondary-hero-text ">
              Based on your driving skills, we have courses for you to pass
              test.
            </p>
            <div className="postal-code justify-content-center align-items-center">
              <input
                type="text"
                className="mail-input"
                placeholder="Enter your Post Code"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
              />
              <div className="vertical-line"></div>
              <Link to="/courses">
                <button className="btn postal-button">
                  Start Your Journey
                </button>
              </Link>
            </div>
            <div className="postal-code-mobile d-md-none justify-content-center align-items-center">
              <input
                type="text"
                className="mail-input"
                placeholder="Enter your Postcode"
                required
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
              />
              {/* <Link to="/courses/beginner"> */}
              <Link to="/courses">
                {" "}
                <button className="d-md-none mobile-postal-button ">
                  Start Your Journey
                </button>
              </Link>
            </div>
          </div>
          {/* <div className="instructor-input-column hero-image-container"> */}
          <div className="instructor-input-column">
            <img
              className="hero-image"
              srcSet={`/Assets/Hero-Section-Car-small.webp 400w,
           /Assets/Hero-Section-Car-medium.webp 800w,
           /Assets/Hero-Section-Car.webp 1200w`}
              //     srcSet={`${process.env.PUBLIC_URL}/Assets/Hero-Section-Car-small.webp 400w,
              //  ${process.env.PUBLIC_URL}/Assets/Hero-Section-Car-medium.webp 800w,
              //  ${process.env.PUBLIC_URL}/Assets/Hero-Section-Car.webp 1200w`}
              sizes="(max-width: 600px) 400px, (max-width: 1200px) 800px, 1200px"
              src={`/Assets/Hero-Section-Car.webp`}
              // src={require("../Assets/Hero-Section-Car.webp")}
              alt="Hero"
              loading="lazy"
            />
            {/* <div className="bg-white border-round-lg text-center"> */}
            <div className="md:flex justify-content-center align-items-center mx-2 w-full">
              <div
                className="cursor-pointer animate-blink bg-white border-round-lg text-center w-12 md:w-10 lg:w-8"
                onClick={() => {
                  // console.log("Book Single Lesson clicked");
                  setTrialLessonModalVisible(true);
                }}
              >
                <span className=" text-lg ">Book Single Lesson</span>
              </div>
            </div>
            {/* </div> */}
            {/* <Button
              className="btn btn-primary md:hidden"
              label="Book Single Lesson"
              onClick={() => {
                console.log("Book Single Lesson clicked");
                setTrialLessonModalVisible(true);
              }}
            /> */}
          </div>
        </div>
      </div>
      <TrailLessonModal
        visible={trialLessonModalVisible}
        setVisible={setTrialLessonModalVisible}
      />
    </div>
  );
};
export default HeroSection;
